
<span :aria-hidden="!title"
      :aria-label="title"
      class="material-design-icon brightness6-icon"
      role="img"
      v-bind="$attrs"
      @click="$emit('click', $event)">
  <svg :fill="fillColor"
       class="material-design-icon__svg"
       :width="size"
       :height="size"
       viewBox="0 0 24 24">
    <path d="M12,18V6A6,6 0 0,1 18,12A6,6 0 0,1 12,18M20,15.31L23.31,12L20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31Z">
      <title v-if="title">{{ title }}</title>
    </path>
  </svg>
</span>
